// JsFromRoutes CacheKey 0a362191e5e777c1cdd43dc4468d3bd6
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  new: /* #__PURE__ */ definePathHelper('get', '/signup'),
  create: /* #__PURE__ */ definePathHelper('post', '/signup'),
}
